import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsModel } from 'src/app/core/models/page.model';
import { CommonService } from 'src/app/core/services/auth/common.service';

@Component({
  selector: 'app-web-view-notifications',
  templateUrl: './web-view-notifications.component.html',
  styleUrls: ['./web-view-notifications.component.scss']
})
export class WebViewNotificationsComponent implements OnInit {
  id: number = 0
  item: NotificationsModel = new NotificationsModel
  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
    this.route.params.subscribe((params: any) => {
      this.id = params.id
    })

  }

  ngOnInit(): void {
    this.getData()
  }

  async getData() {
    const item = await this.commonService.notify(this.id);
    console.log('item : ',item);
    if(item){
      this.item  = item
    }
  }
}
